
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay-result",
      function () {
        return require("private-next-pages/pay-result.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay-result"])
      });
    }
  